/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { Field, FormikProvider, useFormik } from 'formik'
import { requestPassword } from '../core/_requests'
import { EMAIL_INVALID_FORMAT, EMAIL_REQUIRED, FORGET_PASSWORD_TITLE } from '../../../utlis/messages'
import FieldInputText from '../../common/FieldInputText'
import SubmitButton from '../../common/SubmitButton'
import { useDispatch, useSelector } from 'react-redux'
import { ForgetPasswordAction } from '../../../redux/features/auth/authActions'
import Logo from "../../../../_metronic/assets/images/logo.png";

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(EMAIL_INVALID_FORMAT)
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required(EMAIL_REQUIRED),
})

export function ForgotPassword() {
  const dispatch: any = useDispatch();
  const forgetPasswordSlice = useSelector((state: any) => state.forgetPasswordSlice)

  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      dispatch(ForgetPasswordAction({ values, navigate }))
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <div className='text-center logo-wrap'>
            {/* <img src={Logo} alt='logo'/> */}
          </div>
          <h1 className='text-dark fw-bolder mb-3'>Hai dimenticato la password?</h1>
          <div className='text-gray-500 fw-semibold fs-6'>
            {FORGET_PASSWORD_TITLE}
          </div>

        </div>
        <div className='fv-row mb-8'>
          <Field
            name="email"
            validate={forgotPasswordSchema}
            label="Email"
            type="email"
            required={true}
            component={FieldInputText}
            placeholder="Email"
          />
        </div>
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <SubmitButton title="Invia" type='submit' loading={forgetPasswordSlice?.loading} />
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-light'
            >
              Annulla
            </button>
          </Link>{' '}
        </div>
        <div className='text-center mt-6'>
          <span className='text-gray-500 fw-semibold fs-6'>
            Did not receive the verification email?{' '}
            <Link to='/auth/resend-verification' className='link-primary fw-bold'>
              Resend it
            </Link>
          </span>
        </div>
      </form>
    </FormikProvider>
  )
}
